import {createContext, useContext} from "react";
import useSWR from "swr";
import {fetchData} from "../../lib/dashboard/data";

export const ProfileContext = createContext();

const ProfileProvider = ({children}) => {

    // GET PROFILE INFO
    const {
        data: profileInfoData,
        isValidating: isProfileInfoValidation,
        isLoading: isProfileInfoLoading
    } = useSWR("/account/profile", fetchData, {
        revalidateOnFocus: false,
    });

    return (
        <ProfileContext.Provider
            value={{
                profileInfoData,
                isProfileInfoValidation,
                isProfileInfoLoading
            }}
        >
            {children}
        </ProfileContext.Provider>
    );
};

export default ProfileProvider;

export function useProfileContext() {
    return useContext(ProfileContext);
}